module.exports = __webpack_public_path__ + "static/media/C_S03.155fc6a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/C_S03.png
// module id = 102
// module chunks = 0